import React, { useState, useEffect } from 'react';
import DeleteWarningForm from './deletewarning.js';
import InfoForm from './infoProfile.js';
import NetworkList from './networklist.js';
import "../css/profileForm.css";
import ReceivedInvites from './receviedInvites.js';
import {BASE_URL} from "../constants"
import { useLanguage } from "../components/Language.js";

function ProfileForm({user, setUser, onClose}) {

    useEffect(() => {
        refreshScore();
    }, [])

    const [previewUrl, setPreviewUrl] = useState(user.profilePicture || ''); 

    const [isWarningVisible, setWarningVisible] = useState(false);
    const [isAbilityInfoVisible, setAbilityInfoVisible] = useState(false);
    const [isLabelInfoVisible, setLabelInfoVisible] = useState(false);
    const [showNetwork, setShowNetwork] = useState(false);
    const [showInvites, setShowInvites] = useState(false);

    const [isEditingUsername, setIsEditingUsername] = useState(false);
    const [isEditingEmail, setIsEditingEmail] = useState(false);
    const [isEditingFirstName, setIsEditingFirstName] = useState(false);
    const [isEditingLastName, setIsEditingLastName] = useState(false);
    const [isEditingAbout, setIsEditingAbout] = useState(false);
    const [isEditingPostcode, setIsEditingPostcode] = useState(false);
    const [isEditingGender, setIsEditingGender] = useState(false);
    const [isEditingCurrentLang, setIsEditingCurrentLang] = useState(false);
    const [isEditingAgeRange, setIsEditingAgeRange] = useState(false);
    const [isEditingLabels, setIsEditingLabels] = useState(false);

    const [newUsername, setNewUsername] = useState(user.username);
    const [newEmail, setNewEmail] = useState(user.email);
    const [newFirstName, setNewFirstName] = useState(user.firstName);
    const [newLastName, setNewLastName] = useState(user.lastName);
    const [newAbout, setNewAbout] = useState(user.about);
    const [newPostcode, setNewPostcode] = useState(user.postcode);
    const [newGender, setNewGender] = useState(user.gender);
    const [newCurrentLang, setNewCurrentLang] = useState(user.currentLang);
    const [newAgeRange, setNewAgeRange] = useState(user.ageRange);

    const [selectedLabels, setSelectedLabels] = useState(user.labels || []);
    const [newLabel, setNewLabel] = useState("");
    const maxLabelLength = 30;

    const [scoreData, setScoreData] = useState("");
    const [scoreLoaded, setScoreLoaded] = useState(false)

    const {language} = useLanguage();

    const translations = {
        en: {
            labelLengthError: "Label cannot be more than [labellength] characters long",
            male: "Male",
            female: "Female",
            nonBinary: "Non-Binary",
            preferNotToSay: "Prefer not to say",
            unknown: "Unknown",
            currentScore: "Current Score: ",
            currentLevel: "Current Level: ",
            about: "About: ",
            firstName: "First Name: ",
            lastName: "Last Name: ",
            postcode: "Postcode",
            email: "e-mail: ",
            gender: "Gender: ",
            ageRange: "Age Range: ",
            languageAbility: "Language Ability: ",
            info: "Info",
            labels: "Labels: ",
            noLabelsSelected: "No labels selected",
            addLabel: "Add Label",
            superuserLocations: "Superuser locations: ",
            notSuperuser: "You are not a superuser at any location",
            deleteAccount: "Delete account", 
            save: "Save",  
            editImage: "Edit image",
            editUsername: "Edit username",
            edit: "Edit",
            save: "Save",
            delete: "Delete",
            noGaelic: "Little/No Gaelic",
            beginner: "beginner",
            intermediate: "intermediate",
            advanced: "advanced",
            fluent: "fluent",
        },

        gd: {
            noGaelic: "Beagan Gàidhlig / Gun Ghàidhlig",
            beginner: "Neach-tòiseachaidh",
            intermediate: "Eadar-mheadhanach",
            advanced: "Adhartach",
            fluent: "Fileanta",
            labelLengthError: "Chan fhaod leubail a bhith nas fhaide na [fad leubail] caractaran a dh'fhaid",
            male: "Fireann",
            female: "Boireann",
            nonBinary: "Neo-Bhìnearaidh",
            preferNotToSay: "B’ fheàrr leam gun a ràdh",
            unknown: "Chan eil fios",
            currentScore: "Sgòr Làithreach: ",
            currentLevel: "Ìre Làithreach: ",
            about: "Mu: ",
            firstName: "Ciad ainm: ",
            lastName: "Sloinneadh: ",
            postcode: "Còd puist",
            email: "Post-d: ",
            gender: "Gnè: ",
            ageRange: "Raon aoise: ",
            languageAbility: "Comas cànain: ",
            info: "Fiosrachadh",
            labels: "Leubailean: ",
            noLabelsSelected: "Chan eil leubailean air an taghadh",
            addLabel: "Cuir ris leubail",
            superuserLocations: "Àiteachan àrd-chleachdaidh: ",
            notSuperuser: "Chan e àrd-chleachdair a th' annad an àite sam bith",
            deleteAccount: "Dubh às cunntas", 
            save: "Sàbhail",
            editImage: "deasaich an dealbh",
            editUsername: "deasaich ainm cleachdaidh",
            edit: "Deasaich",
            save: "Sàbhail",
            delete: "Dùbh às",
            
        },
    };


    const refreshScore = async () => {
        try{

            const response = await fetch(`${BASE_URL}/api/refresh_score/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({username: user.username}),
            });

            if (!response.ok){
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            console.log("Fetched data: ", data);
            setScoreData(data);
            setScoreLoaded(true);

        } catch (error) {
          console.error('Error fetching score data:', error);
        }
      };

      const handleToggleNetwork = () => {
        setShowNetwork(!showNetwork);
    };

    const handleToggleInvites = () => {
        setShowInvites(!showInvites);
    };
    
    const handleAddLabel = () => {
        if (newLabel.length > maxLabelLength) {
            alert(`Label cannot be more than ${maxLabelLength} characters long.`);
        } else if (newLabel && !selectedLabels.includes(newLabel)) {
            setSelectedLabels([...selectedLabels, newLabel]);
            setNewLabel("");
        }
    };

    const handleLabelChange = (label) => {
        if (selectedLabels.includes(label)) {
            setSelectedLabels(selectedLabels.filter((item) => item !== label));
        }  
        
        else {
            setSelectedLabels([...selectedLabels, label]);
        }
    };


    const handleProfilePictureChange = async (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreviewUrl(URL.createObjectURL(file));

            console.log("username: ", user.username)

            const formData = new FormData();
            formData.append('profilePicture', file);
            formData.append('username', user.username);

            try {
                const response = await fetch(`${BASE_URL}/api/upload_profile_picture/`, {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log("Return from upload: ", data)

                    setUser((prevUser) => {
                        const updatedUser = {
                            ...prevUser,
                            profilePicture: data.profilePictureUrl,
                        };
    
                        var user_info = JSON.parse(sessionStorage.getItem("USER"));
                        user_info['profilePicture'] = data.profilePictureUrl;
                        sessionStorage.setItem("USER", JSON.stringify(user_info));

                    });
                
                } else {
                    console.error('Failed to upload profile picture');
                }
            } catch (error) {
                console.error('Error uploading profile picture:', error);
            }
        }
    };

    const handleDeleteProfileClick = () => {
        setWarningVisible(!isWarningVisible);
      };

    const handleConfirmDelete = async (username) => {

        console.log("In handle confirm delete");
        
        const response = await fetch(`${BASE_URL}/api/delete_user/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username }),
        });
    
        if (response.ok) {
          
          sessionStorage.clear();
          window.location.href = '/map'
        } 
        
        else {
          console.error("Failed to delete the user");
        }
      };

    const handleUpdateDetail = async (field, newDetail) => {

        // console.log("In handleUpdateDetail");
        // console.log("field: ", field);
        // console.log("newDetail: ", newDetail);
        // console.log("username: ", user.username);
    
        const payload = {
          field, 
          newDetail, 
          "username" : user.username,
      };
    
        const response = await fetch(`${BASE_URL}/api/update_detail/`, {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
    
          body: JSON.stringify(payload),
      });
    
      if (field === "first_name"){
        setUser(prevUser => ({
          ...prevUser,
          firstName: newDetail,
      
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['firstName'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingFirstName(false);
      }
    
      else if (field === "last_name") {
        setUser(prevUser => ({
          ...prevUser,
          lastName: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['lastName'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingLastName(false);
      }
    
      else if (field === "about") {
        setUser(prevUser => ({
          ...prevUser,
          about: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['about'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingAbout(false);
      }
    
      else if (field === "postcode") {
        setUser(prevUser => ({
          ...prevUser,
          postcode: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['postcode'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingPostcode(false);
      }
    
      else if(field === "gender"){
        setUser(prevUser => ({
          ...prevUser,
          gender: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['gender'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingGender(false);
      }
    
      else if(field === "current_lang"){
        setUser(prevUser => ({
          ...prevUser,
          current_lang: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info['currentLang'] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingCurrentLang(false);
      }
    
      else if (field === "email") {
        setUser(prevUser => ({
          ...prevUser,
          email: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info["email"] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingEmail(false)
      }
    
      else if (field === "username") {
        setUser(prevUser => ({
          ...prevUser,
          username: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info["username"] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingUsername(false)
      }

      else if (field === "age_range") {
        setUser(prevUser => ({
          ...prevUser,
          ageRange: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info["ageRange"] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingAgeRange(false)
      }

      else if (field === "labels") {
        setUser(prevUser => ({
          ...prevUser,
          labels: newDetail,
        }));
    
        var user_info = JSON.parse(sessionStorage.getItem("USER"));
        user_info["labels"] = newDetail;
        sessionStorage.setItem("USER", JSON.stringify(user_info));
        setIsEditingLabels(false)
      }
    
      };

    const handleDeleteClick = async (field) => {

        console.log("In handle delete click function")
    
        const payload = {
            "field" : field,
            "username" : user.username,
        };
    
        const response = await fetch(`${BASE_URL}/api/delete_field/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
    
            body: JSON.stringify(payload),
        });
    
        const data = await response.json();
        console.log("Response from delete_field: ", data)
    
        if (field === "about"){
    
          setUser(prevUser => ({
            ...prevUser,
            about: data.newEntry,
          }));
    
          var user_info = JSON.parse(sessionStorage.getItem("USER"));
          user_info['about'] = data.newEntry;
          sessionStorage.setItem("USER", JSON.stringify(user_info));
        }

        if (field === "first_name"){

            setUser(prevUser => ({
                ...prevUser,
                firstName: data.newEntry,
            }));
        
            var user_info = JSON.parse(sessionStorage.getItem("USER"));
            user_info['firstName'] = data.newEntry;
            sessionStorage.setItem("USER", JSON.stringify(user_info));
        }

        if (field === "last_name"){

            setUser(prevUser => ({
                ...prevUser,
                lastName: data.newEntry,
            }));
        
            var user_info = JSON.parse(sessionStorage.getItem("USER"));
            user_info['lastName'] = data.newEntry;
            sessionStorage.setItem("USER", JSON.stringify(user_info));
        }

        if (field === "postcode"){

            setUser(prevUser => ({
                ...prevUser,
                lastName: data.newEntry,
            }));
        
            var user_info = JSON.parse(sessionStorage.getItem("USER"));
            user_info['postcode'] = data.newEntry;
            sessionStorage.setItem("USER", JSON.stringify(user_info));
        }
    
    };
    

    const getGenderLabel = (gender) => {
        switch(gender) {
            case 0:
                return "Male";
            case 1:
                return "Female";
            case 2:
                return "Non-binary";
            case 3:
                return "prefer not to say"
            default:
                return "Unknown";
        }
    };

    const getLanguageLabel = (lang) => {
        switch(lang) {
            case 0:
                return " Little/No Gaelic";
            case 1:
                return " Beginner";
            case 2:
                return " Intermediate";
            case 3:
                return " Advanced";
            case 4:
                return " Fluent";
            default:
                return " Unknown";
        }
    };

    const getAgeRangeLabel = (ageRange) => {
        switch(ageRange) {
            case 0:
                return "16 to 24";
            case 1:
                return "25 to 34";
            case 2:
                return "35 to 44";
            case 3:
                return "45 to 54";
            case 4:
                return "55 to 65";
            case 5:
                return "65+";
            case 6:
                return "Prefer not to say";
            default:
                return "Unknown";
        }
    };


    return (
        <>
        <div className='profile-form-container'>

            <div className='profile-header'>

                <div id="profile-pic">

                    <img
                        id="profile-pic-display"
                        src={previewUrl || (user.profilePicture ? `${BASE_URL}/${user.profilePicture}` : `${BASE_URL}/static/images/default-profile.png`)}
                        alt = "Profile Picture"
                    />
                    {/* <p>PictureURL: {user.profilePicture}</p> */}


                    <p id="username-display">
                    {isEditingUsername ? (
                        <input
                            className="form-input form-control"
                            type = "text"
                            value = {newUsername}
                            onChange = {(e) => setNewUsername(e.target.value)}
                        />
                    ): (
                    user.username 
                    )}
                    </p>

                </div>

                <button className="close-x" type = "button" onClick = {onClose}>&times;</button>
            </div>

            <label className="profile-page-edit mb-2" for="upload-new-picture">{translations[language].editImage}</label>
            <input id="upload-new-picture" type="file" onChange={handleProfilePictureChange} accept="image/*" />


            {isEditingUsername ? (
                <button className="profile-page-edit mb-3" onClick = {() => handleUpdateDetail("username", newUsername)}>{translations[language].save}</button>
            ): (
                <>
                <button className="profile-page-edit mb-3" onClick = {() => setIsEditingUsername(true)}>{translations[language].editUsername}</button>
                </>
            )}

            <button className="profile-page-edit mb-3" onClick={handleToggleNetwork}> {showNetwork ? "Hide Network" : "Show Network"}</button>
            <button className="profile-page-edit mb-3" onClick={handleToggleInvites}> {showInvites ? "Hide Invites" : "Show Invites"}</button>

            {scoreLoaded && (
                <div id="score-display">
                    <p>{translations[language].currentScore} {scoreData.score}</p>
                    <p>{translations[language].currentLevel} {scoreData.level}</p>
                </div>
            )}

            <div className="profile-row">
                <p>{translations[language].about}
                    {isEditingAbout ? (
                        <textarea
                            className="mt-2 form-input form-control"
                            value = {newAbout}
                            onChange = {(e) => setNewAbout(e.target.value)}
                            rows = "3"
                            cols = "50"
                            style= {{ width: "100%" }}
                        />
                    ):(
                        user.about
                    )}
                </p>

                <div className="profile-row">
                    {isEditingAbout ? (
                        <>
                        <button className="profile-edit" onClick={() => handleUpdateDetail("about", newAbout)}>{translations[language].save}</button>
                        </>
                    ):(
                        <>
                        <button className="profile-edit" onClick={() => setIsEditingAbout(true)}>{translations[language].edit}</button>
                        <button className="profile-delete" onClick={() => handleDeleteClick("about")}>{translations[language].delete}</button>
                        </>
                    )}
                </div>
            </div>



            <div className="profile-row">
                <p>{translations[language].firstName} 
                    {isEditingFirstName ? (
                        <input
                            className="form-input form-control"
                            type = "text"
                            value = {newFirstName}
                            onChange = {(e) => setNewFirstName(e.target.value)}
                        />
                    ):(
                        user.firstName
                    )}
                </p>
                
                <div>
                    {isEditingFirstName ? (
                        <button className="profile-edit" onClick={() => handleUpdateDetail("first_name", newFirstName)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button className="profile-delete" onClick={() => handleDeleteClick("first_name")}>{translations[language].delete}</button>
                        <button className="profile-edit" onClick={() => setIsEditingFirstName(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>
            </div>


            <div className="profile-row">
                <p>{translations[language].lastName}
                    {isEditingLastName ? (
                        <input
                            className="form-input form-control"
                            type = "text"
                            value = {newLastName}
                            onChange = {(e) => setNewLastName(e.target.value)}
                        />
                    ):(
                        user.lastName
                    )}
                </p>

                <div>
                
                    {isEditingLastName ? (
                        <button className="profile-edit" onClick={() => handleUpdateDetail("last_name", newLastName)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button className="profile-delete" onClick={() => handleDeleteClick("last_name")}>{translations[language].delete}</button>
                        <button className="profile-edit" onClick={() => setIsEditingLastName(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>
            </div>



            <div className="profile-row">
                <p>{translations[language].postcode}:
                    {isEditingPostcode ? (
                        <input
                            className="form-input form-control"
                            type = "text"
                            value = {newPostcode}
                            onChange = {(e) => setNewPostcode(e.target.value)}
                        />
                    ):(
                        user.postcode
                    )}
                </p>

                <div>
                    {isEditingPostcode ? (
                        <button className="profile-edit" onClick={() => handleUpdateDetail("postcode", newPostcode)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button className="profile-delete" onClick={() => handleDeleteClick("postcode")}>{translations[language].delete}</button>
                        <button className="profile-edit" onClick={() => setIsEditingPostcode(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>
            </div>



            <div className="profile-row">

                <p>{translations[language].email}
                    {isEditingEmail ? (
                        <input
                            className="form-input form-control"
                            type = "text"
                            value = {newEmail}
                            onChange = {(e) => setNewEmail(e.target.value)}
                        />
                    ): (
                    user.email 
                    )}
                </p>

                <div>

                    {isEditingEmail ? (
                        <button className="profile-edit" onClick = {() => handleUpdateDetail("email", newEmail)}>{translations[language].save}</button>
                    ): (
                        <>
                        <button className="profile-edit" onClick = {() => setIsEditingEmail(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>
            </div>


            <div className="profile-row">
                <p>{translations[language].gender}
                    {isEditingGender ? (
                        <select
                            value = {newGender}
                            onChange = {(e) => setNewGender(parseInt(e.target.value, 10))}
                        >
                            <option value = "0">{translations[language].male}</option>
                            <option value = "1">{translations[language].female}</option>
                            <option value = "2">{translations[language].preferNotToSay}</option>
                        </select>
                    ):(
                        getGenderLabel(user.gender)
                    )}
                </p>

                <div>
                    {isEditingGender ? (
                        <button className="profile-edit" onClick={() => handleUpdateDetail("gender", newGender)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button className="profile-edit" onClick={() => setIsEditingGender(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>

            </div>


            <div className="profile-row">
                <p>{translations[language].ageRange}
                    {isEditingAgeRange ? (
                        <select
                            value = {newAgeRange}
                            onChange = {(e) => setNewAgeRange(parseInt(e.target.value, 10))}
                        >
                            <option value="0">16 to 24</option>
                            <option value="1">25 to 34</option>
                            <option value="2">35 to 44</option>
                            <option value="3">45 to 54</option>
                            <option value="4">55 to 65</option>
                            <option value="5">65+</option>
                            <option value="6">{translations[language].preferNotToSay}</option>
                        </select>

                    ):(
                        getAgeRangeLabel(user.ageRange)
                    )}
                </p>

                <div>
                    {isEditingAgeRange ? (
                        <>
                        <button className="profile-edit" onClick={() => handleUpdateDetail("age_range", newAgeRange)}>{translations[language].save}</button>
                        </>
                    ):(
                        <>
                        <button className="profile-edit" onClick={() => setIsEditingAgeRange(true)}>{translations[language].edit}</button>
                        </>
                    )}
                </div>

            </div>


            <div className="profile-row">

                <p>{translations[language].languageAbility}
                    {isEditingCurrentLang ? (
                        <select
                            value = {newCurrentLang}
                            onChange = {(e) => {setNewCurrentLang(parseInt(e.target.value, 10)); console.log(parseInt(e.target.value, 10))}}
                        >
                            <option value = "0">{translations[language].noGaelic}</option>
                            <option value = "1">{translations[language].beginner}</option>
                            <option value = "2">{translations[language].intermediate}</option>
                            <option value = "3">{translations[language].advanced}</option>
                            <option value = "4">{translations[language].fluent}</option>
                        </select>
                    ):(
                        getLanguageLabel(user.currentLang)
                    )}
                </p>

                <div>
                
                    {isEditingCurrentLang ? (
                        <button className="profile-edit" onClick={() => handleUpdateDetail("current_lang", newCurrentLang)}>{translations[language].save}</button>
                    ):(
                        <>
                        <button className="profile-edit" onClick={() => setIsEditingCurrentLang(true)}>{translations[language].edit}</button>
                        <button className="profile-info" onClick={() => setAbilityInfoVisible(!isAbilityInfoVisible)}>{translations[language].info}</button>
                        </>
                    )}
                </div>
            </div>

            {isAbilityInfoVisible && (
                <InfoForm
                    info_num={1}
                    onClose = {() => setAbilityInfoVisible(false)}
                />
            )}


            <div id="label-row" className="mb-3">
    
            <p id="label-key">{translations[language].labels}

                {isEditingLabels ? (
                    <>
                    <button className="profile-edit" onClick={() => handleUpdateDetail("labels", selectedLabels)}>{translations[language].save}</button>
                    </>
                ) : (
                    <>
                    <button className="profile-edit" onClick={() => setIsEditingLabels(true)}>{translations[language].edit}</button>
                    <button className="profile-info" onClick={() => setLabelInfoVisible(!isLabelInfoVisible)}>{translations[language].info}</button>
                    </>
                )}
            </p>

            {isEditingLabels ? (
               <>
                {user.labels && user.labels.length > 0 ? (
                    
                    user.labels.map((label, index) => (
                        
                        <div className="form-check ms-2" key={index}>

                            <input
                                type="checkbox"
                                checked={selectedLabels.includes(label)}
                                className="form-check-input form-input"
                                value={label}
                                onChange={() => handleLabelChange(label)}
                            />
                             <span key={index} className="checkbox-label">{label}</span>

                        </div>
                    ))

                ) : (

                    <p className="fw-bold">{translations[language].noLabelsSelected}</p>
                )}

                {selectedLabels !== undefined && selectedLabels.length !== 0 && selectedLabels.map((label, index) => (
                    <>
                    {!user.labels.includes(label) && (
                        <div className="form-check ms-2">
                            
                            <input
                                type="checkbox"
                                checked
                                className="form-check-input form-input"
                                value={label}
                                onChange={() => handleLabelChange(label)}
                            />
                            <span key={index} className="checkbox-label">{label}</span>
                            
                        </div>
                    )}
                    </>
                ))}

                </>
            ) : (
   
                user.labels && user.labels.length > 0 ? (
    
                    user.labels.map((label, index) => (
                        <p className="label-entry" key={index}>{label}</p>
    
                    ))
    
                ) : (
                    <p className="fw-bold">{translations[language].noLabelsSelected}</p>
                )
            
            )}
            </div>

            {isLabelInfoVisible && (
                <InfoForm
                    info_num={2}
                    onClose = {() => setLabelInfoVisible(false)}
                />
            )}

       


        {isEditingLabels && (
            <div>
                <div className="profile-row mb-3">
                    <input
                        className="form-input form-control me-2"
                        type="text"
                        value={newLabel}
                        onChange={(e) => setNewLabel(e.target.value)}
                        placeholder="Enter new label"
                    />
                    <button className="add-label" onClick={handleAddLabel}>{translations[language].addLabel}</button>
                </div>
            </div>

        )}

        <div className="profile-row">
            <h3>{translations[language].superuserLocations}</h3>
                {user.locations && user.locations.length > 0 ? (
                    <ul>
                        {user.locations.map((location, index) => (
                            <li key={index}>{location}</li>
                        ))}
                    </ul>
                ) : (
                    <p>{translations[language].notSuperuser}</p>
                )}
        </div>


            <div>   
                <button id="profile-delete" onClick={handleDeleteProfileClick}>{translations[language].deleteAccount}</button>
            </div>

            <div>
                {isWarningVisible && (
                    <DeleteWarningForm
                        username={user.username}
                        onCancel={() => setWarningVisible(false)}
                        onConfirm={handleConfirmDelete}
                    />
                )}
            </div>
        </div>

        


        {showNetwork && ( 
            <NetworkList 
                username={user.username}
                fromEvent={false}
                fromProfile={true}
                onClose={() => setShowNetwork(false)} 
            />
        )}

        {showInvites && ( 
            <ReceivedInvites 
                username={user.username}
                onClose={() => setShowInvites(false)} 
            />
        )}

        </>

        
    );
}

export default ProfileForm;